import { ReactComponent as CompanyIconSVG } from '@/assets/icons/CompanyIcon.svg';
import { SVGProps } from 'react';

const CompanyIcon = (props: SVGProps<SVGSVGElement>) => <CompanyIconSVG {...props} />;

export default CompanyIcon;
